import type { ComponentStore } from "@schemas/shared/componentStoreSchema";

import type { ComponentStoreData } from "./types";

const mapVisibleComponentsToComponents = (rawStore: ComponentStore | undefined): Record<string, string[]> => {
  const components: Record<string, string[]> = {};

  for (const component of rawStore?.visible_components ?? []) {
    if (component.name && Array.isArray(component.values)) {
      components[component.name] = component.values;
    }
  }

  return components;
};

export const normalizeComponentStore = (rawStore: ComponentStore | undefined): ComponentStoreData => {
  const normalizedStoreData: ComponentStoreData = {
    components: mapVisibleComponentsToComponents(rawStore),
    deactivatedValues: rawStore?.deactivated_values ?? {},
  };
  if (rawStore?.new_values) {
    normalizedStoreData.newValues = rawStore.new_values;
  }
  if (rawStore?.variant_metadata) {
    normalizedStoreData.variantMetadata = rawStore.variant_metadata;
  }
  return normalizedStoreData;
};

export const isComponentStore = (
  componentStoreData: ComponentStoreData | ComponentStore
): componentStoreData is ComponentStore => {
  return Array.isArray((componentStoreData as ComponentStore).visible_components);
};

export const normalizeNullableComponentStore = (
  rawStore: ComponentStore | undefined
): ComponentStoreData | null => {
  if (!rawStore?.visible_components) {
    return null;
  }

  return normalizeComponentStore(rawStore);
};
